import React from 'react';
import styled from 'styled-components';
import { useTextViewStore } from '../../shared/store/TextViewStore';
import TextBlock from './TextBlock';


const TextBlockList: React.FC = () => {
  const activeText = useTextViewStore((s) => s.activeText);
  const activeTextBlockList = useTextViewStore((s) => s.activeTextBlockList);

  if (!activeText || activeTextBlockList.length === 0) return null;

  return (
    <TextBlockContainer>
      {activeTextBlockList.map((tb) => (
        <TextBlock key={tb.id} data={tb} />
      ))}
    </TextBlockContainer>
  );
};

const TextBlockContainer = styled.div`
  position: relative;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 30px 0;
  gap: 20px;
`;

export default TextBlockList;
